export const getQueryStringParams = (query) => {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params, param) => {
            let [key, value] = param.split('=')
            // For email parameters, don't replace + with space
            if (key === 'email') {
                params[key] = value ? decodeURIComponent(value) : ''
            } else {
                params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
            }
            return params
        }, {})
        : {}
}
